/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Home_Nexy_Feature_4_DescInputs */

const es_home_nexy_feature_4_desc = /** @type {(inputs: Home_Nexy_Feature_4_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hace preguntas en lenguaje cotidiano. Nexy interpreta intención, no solo comandos.`)
};

const en_home_nexy_feature_4_desc = /** @type {(inputs: Home_Nexy_Feature_4_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ask questions in everyday language. Nexy interprets intent, not just commands.`)
};

/**
* | output |
* | --- |
* | "Ask questions in everyday language. Nexy interprets intent, not just commands." |
*
* @param {Home_Nexy_Feature_4_DescInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const home_nexy_feature_4_desc = /** @type {((inputs?: Home_Nexy_Feature_4_DescInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Nexy_Feature_4_DescInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_home_nexy_feature_4_desc(inputs)
	return en_home_nexy_feature_4_desc(inputs)
});
export { home_nexy_feature_4_desc as "home.nexy.feature_4_desc" }